import useMe from "@/hooks/useMe";
import { ReactElement, Suspense, lazy } from "react";
import MainLoading from "../MainLoading";

const Forbidden = lazy(() => import("@/pages/Forbidden"));

export default function ResellerRequiredWrapper({
  element,
}: {
  element: ReactElement;
}) {
  const { meData: authenticatedUser } = useMe();

  if (!authenticatedUser) {
    return <MainLoading />;
  }

  if (authenticatedUser.parceiro === null) {
    return (
      <Suspense fallback={<MainLoading />}>
        <Forbidden />
      </Suspense>
    );
  }

  return element;
}
